export default "__VITE_ASSET__BskorpKx__"